import * as type from "../../types/API/batchItemsType";
import { IAction } from "../userMetadataReducer";

const initialState = {
  batchItems: [],
  loading: false,
  error: null,
  data: null,
};

export const getBatchItems = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_BATCHITEMS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_BATCHITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        batchItems: action.payload.responseData,
        data: action.payload.responseData?.message
      };
    case type.GET_BATCHITEMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};




export const updateBatchItems = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.UPDATE_BATCHITEMS:
      return {
        ...state,
        loading: true,
      };
    case type.UPDATE_BATCHITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        batchItems: action.payload.responseData,
      };
    case type.UPDATE_BATCHITEMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};




export const createBatchItems = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.CREATE_BATCHITEMS:
      return {
        ...state,
        loading: true,
      };
    case type.CREATE_BATCHITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        batchItems: action.payload.responseData,
        data: action.payload.responseData?.message,
      };
    case type.CREATE_BATCHITEMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const createSelectBatchItems = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.CREATE_SELECT_BATCHITEMS:
      return {
        ...state,
        loading: true,
      };
    case type.CREATE_SELECT_BATCHITEMS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData?.message,
      };
    case type.CREATE_SELECT_BATCHITEMS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};